import {NotificationContextBar} from '@/features/notifications/components/notification-context-bar/NotificationContextBar'
import {useNotificationWorkContext} from '@/features/notifications/hooks/useNotificationWorkContext'
import {useNotificationContextHostStore} from '@/features/notifications/store/useNotificationContextHostStore'
import {hasPageDestination} from '@/features/notifications/utils/notificationScope'
import {StyledNotificationContextBarRow} from './style'

/**
 * Mounts the wide form of the work-context bar once, in PrivateLayout's reserved row.
 *
 * The row element is always rendered so `<Outlet />` keeps its own grid row; it collapses to
 * zero height whenever the bar has nothing to show — because there is no work context, because
 * a surface on screen has claimed the bar and renders it inside itself, or because the task has
 * no page for a wide band to belong to.
 */
export const NotificationContextBarHost = () => {
    const hostId = useNotificationContextHostStore(state => state.hostId)
    const {notification} = useNotificationWorkContext()

    // The wide band states which task the *page* below it belongs to. A task whose only
    // destination is an overlaying surface — an internal conversation, which the backend sends
    // with no link at all — has no such page: it was opened on whatever page the operator was
    // already on, so once that surface is closed the band would name work that is nowhere on
    // screen and cannot be got back to from here.
    //
    // Hidden, not ended: the context stays on the address, so reopening the conversations shows
    // the task again inside them, and navigating away still ends it (FR-017d). Same treatment
    // the notifications panel already gets while it is open.
    const belongsToThisPage = !!notification && hasPageDestination(notification)

    return (
        <StyledNotificationContextBarRow>
            {hostId === null && belongsToThisPage && <NotificationContextBar variant="wide" />}
        </StyledNotificationContextBarRow>
    )
}
